import { Link } from 'react-router-dom';
import { platforms } from '@/mocks/platforms';

export default function PlatformGrid() {
  const featuredPlatforms = platforms.slice(0, 8);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            精选<strong>po文网站</strong>推荐
          </h2>
          <p className="mt-3 text-foreground-500 max-w-xl mx-auto">
            经过深度评测和用户口碑验证，为你精选最值得关注的原创内容发布平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
          {featuredPlatforms.map((platform) => (
            <a
              key={platform.id}
              href={platform.url}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="group bg-background-50 border border-background-200 rounded-xl p-5 hover:border-primary-300 transition-all duration-300 cursor-pointer block"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                <i className="ri-book-read-line text-xl text-primary-600"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                {platform.name}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                {platform.description}
              </p>
              <div className="mt-4 flex items-center gap-1">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i
                    key={star}
                    className={`ri-star-fill text-xs ${
                      star <= Math.floor(platform.rating)
                        ? 'text-accent-500'
                        : 'text-background-300'
                    }`}
                  ></i>
                ))}
                <span className="ml-1.5 text-xs font-semibold text-foreground-700">
                  {platform.rating}
                </span>
              </div>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {platform.features.slice(0, 3).map((feat) => (
                  <span
                    key={feat}
                    className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700"
                  >
                    {feat}
                  </span>
                ))}
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部平台
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}